import type { IStep1Props, ICategortItem, IProductListProps, IResultProduct } from '../cacl';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Image from '@/components/UI/Image';

/**
 * pc 商品列表
 * @param {productList, goStep2}
 * @returns JSX.Element
 */
function ProductListPc({ productList, goStep2 }: IProductListProps) {
    return (
        <>
            {productList.map((category, idx) => (
                <div className="categortItem" key={idx}>
                    <h6 className="categortName font-family-semibold">{category.categoryName}</h6>
                    <ul className="productList">
                        {category.list.map((productItem, productIdx) => (
                            <li
                                className="productItem font-family-medium"
                                key={`${idx}+${productIdx}`}
                                onClick={() => goStep2(productItem.key, productItem.productName, category.categoryName)}
                            >
                                <div className="productImg">
                                    <Image src={productItem.imgPc} layout="fill" alt={productItem.productName} />
                                </div>
                                <p className="productName">{productItem.productName}</p>
                                <div className="productPower">
                                    <span className="power">{productItem.power}</span>
                                    <span className="unit">{productItem.unit}</span>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </>
    );
}

/**
 * H5 商品列表
 * @param {productList, goStep2}
 * @returns JSX.Element
 */
function ProductListH5({ productList, goStep2 }: IProductListProps) {
    const formatProduct = (productList: ICategortItem[]) => {
        const resultProductList: IResultProduct[] = [];
        productList.forEach((categortItem) => {
            categortItem.list.forEach((productItem) => {
                resultProductList.push({ ...productItem, categoryName: categortItem.categoryName });
            });
        });
        return resultProductList;
    };
    return (
        <div className="categortItem">
            <ul className="productList">
                {formatProduct(productList).map((productItem, productIdx) => (
                    <li
                        className="productItem font-family-medium"
                        key={productIdx}
                        onClick={() => goStep2(productItem.key, productItem.productName, productItem.categoryName)}
                    >
                        <div className="productImg">
                            <Image src={productItem.imgH5} layout="fill" alt={productItem.productName} />
                        </div>
                        <p className="productName">{productItem.productName}</p>
                        <div className="productPower">
                            <span className="power">{productItem.power}</span>
                            <span className="unit">{productItem.unit}</span>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}

/**
 * Step1 组件
 * @returns JSX.Element
 */
export default function Step1({ productList, setSelectInfo }: IStep1Props) {
    const { isMobile, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('calculatorssolarpanels');
    const router = useRouter();
    const { locale } = router;
    const goStep2 = (productkey: string, productName: string, categortName: string) => {
        const selectStorage = { productkey, chargTime: 2, activeStep: 2 };
        setSelectInfo(selectStorage);
        gtm.push({
            event: 'uaEvent',
            event_name: 'calculator1_solar_panels',
            step: 'select device',
            button_name: 'none',
            product_name: productName,
            list_name: categortName,
            option_name: productName,
        });
        router.push({
            pathname: `/${locale}/calculators/solarpanels`,
            query: {
                step: 2,
            },
        });
    };
    const ProductList = isMobile ? ProductListH5 : ProductListPc;
    return (
        <div className={css.step1}>
            <h3 className="calc-solar-step1-title">{t('cacl_step1_title')}</h3>
            <div className="product-list-wrap">
                <ProductList productList={productList} goStep2={goStep2} />
            </div>
        </div>
    );
}
